var React = require('react');

function Projects (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","stroke":"#58595B","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10"},[React.createElement("path",{"d":"M12.5 3.5l-4 4 7 7v3.992L22 17l1.5-7.5-4.5.5z","key":0}),React.createElement("path",{"d":"M13.25 12.25L4.5 21v2.5h-4v-3.991l6.635-5.189L10.5 9.5M14.5 5.5L16 4l3 3-1.5 1.5M15.5 16.23l4.607-1.425.787-5.015","key":1})]));
}

Projects.displayName = "Projects";

Projects.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Projects;

Projects.default = Projects;



//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/projects.svg
// module id = 387
// module chunks = 213720915766396